// Chakra v2: plain object — createBreakpoints was removed in v2
export const breakpoints = {
  sm: '375px',
  md: '768px',
  lg: '1024px',
  xl: '1440px',
  '2xl': '1680px',
};
